import type { DOMConversionMap } from "lexical";
import type { SerializedSurveyAnswersNode } from "./types";
import { SurveyAnswersNode } from "./survey-answers-node";
import { SurveyAnswersComponent } from "./survey-answers-component";

export class SurveyAnswersNodeMui extends SurveyAnswersNode {
  decorate(): React.JSX.Element {
    return (
      <SurveyAnswersComponent
        nodeKey={this.__key}
        questionBold={this.__questionBold}
        questionItalic={this.__questionItalic}
        questionUnderline={this.__questionUnderline}
        questionColor={this.__questionColor}
        answerBold={this.__answerBold}
        answerItalic={this.__answerItalic}
        answerUnderline={this.__answerUnderline}
        answerColor={this.__answerColor}
      />
    );
  }

  static importJSON(serializedNode: SerializedSurveyAnswersNode): SurveyAnswersNodeMui {
    return super.importJSON(serializedNode);
  }

  exportJSON(): SerializedSurveyAnswersNode {
    return super.exportJSON();
  }

  static clone(node: SurveyAnswersNodeMui): SurveyAnswersNodeMui {
    return super.clone(node);
  }

  static getType(): string {
    return super.getType();
  }

  static importDOM(): DOMConversionMap | null {
    return null;
  }
}
